import React from 'react';
import PropTypes from 'prop-types';
import { Button, CardActions, CardContent, Grid, Paper, Typography } from '@availity/element';

import { saveOaaOrgs } from '@/api';
import { AvailityHeaderLogo, Footer } from '@/components';
import { useAppContext } from '@/context';
import { handleSuccessNavigation, trackEvent } from '@/global';

const OAASkip = ({ ...props }) => {
  const { setCurrentOAAPage, backPage } = props;
  const { queryParams = {}, oaaOrgsResponse, userHasInvites, selectedOAAOrgIds = [] } = useAppContext();

  const { goto } = queryParams;

  const { skipCount, oaaOrganizations } = oaaOrgsResponse;

  const handleBackNavigation = () => setCurrentOAAPage(backPage || 'adminCheckIn');

  const handleSkipNavigation = async () => {
    // build out payload
    const oAAAcknowledgements = [];

    for (const organization of oaaOrganizations) {
      // iterate through each of the organizations to indicate the agreement has been skipped
      const { appId } = organization;

      // need to only push unselected orgs to acknowledgements array if coming from admin change pages
      if (
        backPage === 'adminCheckIn' ||
        backPage === 'viewSelectedOrgs' ||
        (backPage.indexOf('adminChange') >= 0 && selectedOAAOrgIds.indexOf(appId) < 0)
      ) {
        oAAAcknowledgements.push({
          appId,
          oAAAcknowledgementIn: 'N',
        });
      }
    }

    const payload = {
      oAAAcknowledgements,
      isSkip: true,
    };

    // make call to skip the OAA; log any errors before handling success navigation
    try {
      await saveOaaOrgs(payload);
    } catch (error) {
      trackEvent({
        api: 'organization-agreement-api',
        event: 'skip-oaa-failure',
        status: error?.response?.status,
      });
    }

    // for now, no need to stop the user from navigating if there is nothing the user can do to address the error
    handleSuccessNavigation(goto, userHasInvites);
  };

  return (
    <Grid
      id="oaa-skip-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 6 }} display="flex" flexDirection="column" alignItems="center" flexGrow={1}>
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '700px' } }}>
            <CardContent>
              <Typography variant="h1" mb={2}>
                Are you sure you&apos;d like to do this later?
              </Typography>
              <Typography variant="subtitle1">{`We understand you are busy. You may skip this process ${
                2 - skipCount
              } more time${2 - skipCount <= 1 ? '' : 's'} until you must complete the form.`}</Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'end' }}>
              <Button color="secondary" onClick={handleSkipNavigation}>
                Do it later
              </Button>{' '}
              <Button color="primary" onClick={handleBackNavigation}>
                Back
              </Button>
            </CardActions>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </Grid>
  );
};

OAASkip.propTypes = {
  setCurrentOAAPage: PropTypes.func.isRequired,
  backPage: PropTypes.string,
};

export default OAASkip;
